// @ts-nocheck
import * as React from "react";

const Visa: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 20">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M0 1.699C0 .76.764 0 1.706 0h28.588C31.236 0 32 .76 32 1.699V18.3C32 19.24 31.236 20 30.294 20H1.706C.764 20 0 19.24 0 18.301V1.7Zm11.846 12.468 1.424-8.313h2.276l-1.424 8.313h-2.276ZM22.38 6.059a5.905 5.905 0 0 0-2.04-.35c-2.25 0-3.835 1.128-3.848 2.744-.013 1.195 1.131 1.86 1.995 2.258.886.408 1.184.668 1.18 1.032-.006.557-.708.811-1.362.811-.912 0-1.396-.126-2.143-.436l-.294-.132-.32 1.86c.533.233 1.516.434 2.537.444 2.393 0 3.947-1.114 3.964-2.84.009-.945-.598-1.665-1.911-2.258-.796-.385-1.283-.642-1.278-1.03 0-.346.412-.716 1.304-.716a4.22 4.22 0 0 1 1.703.319l.205.096.308-1.802Zm5.838-.197h-1.759c-.545 0-.953.148-1.192.69l-3.381 7.618h2.39s.391-1.025.48-1.25l2.915.004c.068.29.277 1.246.277 1.246h2.113l-1.843-8.308ZM7.47 10.376l.238 1.153L9.937 5.86h2.412l-3.585 8.297-2.408.003L4.33 6.94a9.579 9.579 0 0 0-2.39-.912l.028-.173H5.64c.495.018.894.176 1.032.702l.798 3.82Zm17.94.844.907-2.324c-.014.022.187-.481.302-.793l.154.717.527 2.4h-1.89Z"
            />
        </svg>
    );
};

export default React.memo(Visa);
